export const getResponseMode = (state) =>
  state.reporting[state.userData.currentReportCode].metadata.responseMode;

export const getIsAsync = (state) => getResponseMode(state) === "ASYNC";

export const getIsSync = (state) => getResponseMode(state) !== "ASYNC";

export const getAsyncReq = (state) =>
  state.reporting[state.reporting.currentReportId].isAsyncRequest;

export const getDownloadReportResult = (state) => state.downloadReportResult;

export const getReportCustomFilter = (state) => state.reportCustomFilter;

export const getReportSorting = (state, reportId) =>
  state.reporting[reportId || state.reporting.currentReportId]?.sorting;

export const getReportFiltering = (state, reportId) =>
  state.reporting[reportId || state.reporting.currentReportId]?.filtering;

export const getReportMode = (state, reportId) =>
  state.reporting[reportId || state.reporting.currentReportId]?.reportMode;

export const getReportState = (state, reportId) =>
  state.reporting[reportId || state.reporting.currentReportId];

export const getReportStateFilteringsByColumn = (state, columnId) =>
  state.userData.currentReportCode &&
  state.reporting[state.userData.currentReportCode]?.filtering &&
  state.reporting[state.userData.currentReportCode]?.filtering?.appliedFilters
    ? state.reporting[
        state.userData.currentReportCode
      ]?.filtering.appliedFilters.filter(
        (appliedFilter) => appliedFilter.id === columnId
      )
    : [];

export const getEnabledAsyncSwitch = (state) =>
  state.reporting.enabledAsyncSwitch;

export const getEnabledCancelReport = (state) =>
  state.reporting.enabledCancelReport;

export const getOpenEmailModal = (state) => state.reporting.openEmailModal;
